import { BodyText } from '@workday/canvas-kit-react/text';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { ElementType } from 'react';

export const ThemedBodyText = ({
  as = 'p',
  ...props
}: React.ComponentProps<typeof BodyText> & { as?: ElementType }) => (
  <BodyText color={WcpStyles.color.text.default} as={as} {...props} />
);
